import React from 'react';
import '../style/Gallery.scss';
//  components
import Header from '../components/public/Header';
import PhotoGallery from '../components/thirdParty/PhotoGallery';
// React Bootstrap
import { Container, Tab, Row, Col, Nav, Tabs } from 'react-bootstrap';

function Gallery() {
  const jailPhotos = [
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fjail1.jpeg?alt=media&token=9d90b0e1-3a02-47b9-8273-ea0e20b366f7',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fjail2.jpeg?alt=media&token=01ae1b97-89c7-47bf-99a5-e7dabb8df0d4',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fjail4.jpeg?alt=media&token=293d909d-b311-4b69-9ab2-9e638ba23d01',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fjail5.jpeg?alt=media&token=79e5d986-2562-43ae-a2c6-2ccccce1ea03',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fjail6.jpeg?alt=media&token=70e47303-aded-4f5e-8b64-1b2e491c35eb',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fjail7.jpeg?alt=media&token=dacfa2d2-1da0-41d4-9dc9-53c389563343',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fjail8.jpeg?alt=media&token=8cf3aee1-0723-4398-9019-b529442fa4af',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fjail9.jpeg?alt=media&token=d9be6c3e-3937-4dd0-8749-4bb239211a81',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fjail10.jpg?alt=media&token=1ee9bb91-bdb9-45d2-a093-8c10f628de41',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fjail11.jpg?alt=media&token=0db4b8f0-6c9a-4640-aabe-c4242ae22915',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fjail12.jpeg?alt=media&token=d86e9abb-96a4-4b23-8178-528ac59f6b1c',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fjail13.jpeg?alt=media&token=928e2165-5f0a-400b-be62-0fb349981834',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fjail14.jpeg?alt=media&token=9bb68226-7b6d-4f88-bc94-f007090f25ef',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fjail15.jpeg?alt=media&token=ee688049-3dd4-49db-92ff-27c55a6ce4ae',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fjail16.jpeg?alt=media&token=a2545abe-971b-4adb-abb6-315ff9c10d40',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fjail17.jpg?alt=media&token=289b529f-aea1-4909-b829-05a16cd2f2f4',
      width: 5,
      height: 3,
    },
  ];
  const BDA2016 = [
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA20161.jpg?alt=media&token=9ac43f7e-728a-4838-beba-697114c1a033',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA20162.jpg?alt=media&token=df8b079e-d968-4121-819c-d6c2dbcbd174',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA20163.jpg?alt=media&token=a3f323b8-c402-4444-9523-1735651d2961',
      width: 5,
      height: 3,
    },
  ];
  const BDA2017 = [
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA20171.jpg?alt=media&token=da5ae146-f1dc-4659-92b0-8bd54b7aca6c',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA20172.jpg?alt=media&token=3172bd5c-9e65-4ebf-bb69-58a22ae03fc0',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA20174.jpg?alt=media&token=4c4bf1b3-83c2-4d43-93eb-1a5f7014e5f2',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA20175.jpg?alt=media&token=8aeb0c9b-09ab-4a8d-93ae-e537a9b47aba',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA20176.jpg?alt=media&token=0e484365-d933-4b89-87e2-86e7ae38d6c3',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA20177.jpg?alt=media&token=b1c060f9-95dd-4032-a450-3c89714816d4',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA20178.jpg?alt=media&token=7c345146-57f5-4ce7-bfac-13a529f0a23b',
      width: 5,
      height: 3,
    },
  ];
  const BDA2018 = [
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA201816.jpg?alt=media&token=fe2e2204-1063-4886-88c7-305164bcf79d',
      width: 4,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA201817.jpg?alt=media&token=976d5e79-96e3-4217-89ad-a92c9944d389',
      width: 4,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA201814.jpg?alt=media&token=db26750a-d8b0-48af-a262-23c81b202899',
      width: 4,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA201818.jpg?alt=media&token=b82d3afb-b2b1-4884-a0ac-0400181455ff',
      width: 4,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA20182.jpg?alt=media&token=1664fcd1-bb9b-4962-bf31-ee17b2eacf8e',
      width: 4,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA20183.jpg?alt=media&token=471fb60b-7630-4b43-9425-d7168a55d99c',
      width: 3,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA20184.jpg?alt=media&token=a0e060fa-3d9e-4161-8dbe-438c4bc7bf99',
      width: 3,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA20185.jpg?alt=media&token=3e48a421-479e-41ee-b142-96dc10362e16',
      width: 4,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA20186.jpg?alt=media&token=91869e84-2cc5-4474-b1b5-a0c0f46d25ef',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA20187.jpg?alt=media&token=fb60641c-a4b4-4e29-b3e6-e6919fa6f47c',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA20188.jpg?alt=media&token=29ef94b7-f11b-4fa3-967e-0b0a0f4a1f53',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA20189.jpg?alt=media&token=779b5327-0a65-46bc-b852-c8f47173a2ba',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA201810.jpg?alt=media&token=f111598e-021d-4b88-a39f-366115e5078b',
      width: 3,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA201811.jpg?alt=media&token=c7cd0781-bdf7-40aa-b644-fdfd78d09078',
      width: 4,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA201812.jpg?alt=media&token=027f8a16-bc00-464c-b703-f6d9d7f70da4',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA201813.jpg?alt=media&token=7e334dfa-a6ba-40fb-ba88-722b198bf9ea',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA20181.jpg?alt=media&token=090bfcd1-eeee-4593-ade7-1943acef87cc',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FBDA201819.jpg?alt=media&token=59ab90f3-0ed3-4555-b9a8-9a939ea3870a',
      width: 5,
      height: 3,
    },
  ];

  const meditation = [
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation1.jpg?alt=media&token=4bbd5e3c-1922-434c-a2b3-589eb231a340',
      width: 4,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation2.jpg?alt=media&token=04497e20-0c0f-4940-a531-715851a3e9ca',
      width: 4,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation3.jpg?alt=media&token=1143bbc6-805c-4531-8ba8-950791ca91c6',
      width: 4,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation4.jpg?alt=media&token=ea6798a5-4544-44f7-b626-bce0d887f099',
      width: 4,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation5.jpg?alt=media&token=7802db7e-efc9-4aef-94b6-ef8346a2be3a',
      width: 4,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation6.jpg?alt=media&token=24bf7579-0fae-4a53-89ae-aae550a2396a    ',
      width: 5,
      height: 4,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation7.jpg?alt=media&token=b441038a-ba2f-4121-9680-bbab12842e7f',
      width: 5,
      height: 4,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation8.jpg?alt=media&token=62045871-3805-4c00-b889-046fe5a4e0d7',
      width: 5,
      height: 4,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation9.jpg?alt=media&token=8a0914d1-60fa-47a7-abe1-94ea3e54ed8e',
      width: 3,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation11.jpg?alt=media&token=8939f46e-3d4c-403b-bee1-46a8545c687b',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation12.jpg?alt=media&token=1797c1b2-b697-4c67-a82e-53ab81a9040c',
      width: 3,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation13.jpg?alt=media&token=dfe8db4f-3389-49db-9a35-eb315c3e14a5',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation14.jpg?alt=media&token=bb70d7fc-28b6-49ab-8ff1-47a20d96a967',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation15.jpg?alt=media&token=9643247f-49a0-46d1-9a5b-e17da602070f',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation16.jpg?alt=media&token=5a7ca6bf-c235-4b89-9e8d-c9740bf40184',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation18.jpg?alt=media&token=92697864-cefe-42fc-be43-baeb23693f07',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation19.jpg?alt=media&token=4aa1a7ba-5710-4b9a-afd3-07e8a48a607e',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation20.jpg?alt=media&token=92dd0d66-d9ee-40ed-946d-62355570021d',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation21.jpg?alt=media&token=d985e3f5-0a60-411f-83ed-92823db2e778',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation22.jpg?alt=media&token=9e7d968d-943d-4a1b-98fe-ae5b6cb6e157    ',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation23.jpg?alt=media&token=826207fb-fbd5-4edc-a4db-b07222f8dac7',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation26.jpg?alt=media&token=8a8522c6-f5b4-4432-b812-a282284d68be    ',
      width: 4,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation27.jpg?alt=media&token=2c136456-9afd-4afc-801e-e9c17b3dc547',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation28.jpg?alt=media&token=d87657bc-33fc-45fd-8afe-1a95632747a1',
      width: 3,
      height: 4,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation30.jpg?alt=media&token=65f02201-6016-40bf-83cb-f59b89428d7c',
      width: 3,
      height: 4,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmeditation31.jpg?alt=media&token=31a6a3f6-3f08-4010-9206-8f4d401ae6b9',
      width: 3,
      height: 4,
    },
  ];

  const meditationGuid = [
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FmeditationGuid1.jpeg?alt=media&token=119253b9-d690-443b-bb91-3f4ae212eceb',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FmeditationGuid2.jpeg?alt=media&token=70a9f3e0-9d6a-4585-8b58-28f408aa0ba0',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FmeditationGuid3.jpeg?alt=media&token=4eeea85f-45dc-4440-b011-727af417cc68    ',
      width: 4,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FmeditationGuid4.jpeg?alt=media&token=ee5372d5-0a6b-4a26-bb53-4175540a5058',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FmeditationGuid5.jpeg?alt=media&token=9ad74923-2be3-4a71-b9fd-05100daa1a54',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FmeditationGuid6.jpeg?alt=media&token=d8c1336b-01de-4566-a42d-dd5f98727662',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FmeditationGuid7.jpeg?alt=media&token=4360d74d-0f99-4be9-bb80-2d6216ea0041',
      width: 4,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FmeditationGuid8.jpeg?alt=media&token=f446dc83-e9e9-4f32-91d7-f5b29a69994c',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FmeditationGuid9.jpeg?alt=media&token=95a84911-f4bd-4aff-a467-956d613a07fd',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FmeditationGuid10.jpeg?alt=media&token=c23c371d-10c5-45db-ad1b-120bc0ca0129',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FmeditationGuid11.jpeg?alt=media&token=229116ce-9749-4b50-bd0d-483092488449',
      width: 3,
      height: 4,
    },
  ];

  const interview = [
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Finterview1.jpg?alt=media&token=f7182b63-ee23-4bdb-8d0b-f7e6140c5a79',
      width: 4,
      height: 5,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Finterview3.jpg?alt=media&token=5c91090e-193f-4396-953b-cf2c36abbbe8    ',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Finterview4.jpg?alt=media&token=ae1bbfcd-a2e7-454a-9ae9-c0152c41fd1f',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Finterview5.jpg?alt=media&token=52da86df-8e12-48f3-893b-fc83cf2d521f',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Finterview6.jpg?alt=media&token=5f2a3d71-ac3b-48af-a933-d048249ff6e8',
      width: 5,
      height: 3,
    },
  ];

  const taiwanCenter = [
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtaiwanCenter6.jpg?alt=media&token=9d47f1d0-1698-4082-b5ae-125c89101907',
      width: 4,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtaiwanCenter15.jpg?alt=media&token=0d33c81b-7dc3-42cf-af19-857e4369e1f5',
      width: 2,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtaiwanCenter11.jpg?alt=media&token=c96f3d72-1a84-47d7-9c6c-5e9e5efe1c6f',
      width: 4,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtaiwanCenter12.jpg?alt=media&token=b92d7cc3-5553-41b6-912d-19afdf6d2019',
      width: 4,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtaiwanCenter14.jpg?alt=media&token=4105c19b-a4e9-4612-9b69-a714e09962a2',
      width: 4,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtaiwanCenter16.jpg?alt=media&token=54a45a70-b696-40b6-93c1-fce303fad7ee',
      width: 4,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtaiwanCenter1.jpg?alt=media&token=1601e4ba-b10b-407b-88ba-3b0e15976d16',
      width: 4,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtaiwanCenter2.jpg?alt=media&token=9681594c-1645-411b-8a18-04caab3110dd',
      width: 4,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtaiwanCenter3.jpg?alt=media&token=bbfeceb5-d94f-45cf-a429-6455487d39ec',
      width: 4,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtaiwanCenter4.jpg?alt=media&token=c58fadd1-d08b-4d45-92d3-dd2ba54eb88e',
      width: 3,
      height: 4,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtaiwanCenter7.jpg?alt=media&token=5b80274d-445f-4ef9-b6cf-ce87b53d71a4',
      width: 4,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtaiwanCenter8.jpg?alt=media&token=fcd75787-e71a-4fdc-8063-f69549f74842',
      width: 4,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtaiwanCenter9.jpg?alt=media&token=4115397e-a623-4d1c-a765-4d9ae156d007    ',
      width: 5,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtaiwanCenter10.jpg?alt=media&token=4a9764d4-4621-486f-bc46-3aa246cc9e4b',
      width: 4,
      height: 3,
    },
    {
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtaiwanCenter13.JPG?alt=media&token=d5ed2e87-d6d1-4aa8-983a-af3a3ac7310f',
      width: 4,
      height: 3,
    },
  ];

  const singapore = [
    {
      no: 1,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore1.jpg?alt=media&token=b6709bda-780d-49ed-bdbf-dcedc3f19d36',
      width: 5,
      height: 3,
    },
    {
      no: 2,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore2.jpg?alt=media&token=0a6cac27-b924-48f4-b64d-75a1be3c1386        ',
      width: 5,
      height: 3,
    },
    {
      no: 3,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore3.jpg?alt=media&token=f10a8a77-7d25-4fff-9946-fa10e3c3f362',
      width: 5,
      height: 3,
    },
    {
      no: 4,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore4.jpg?alt=media&token=a8ab068e-5148-4181-b5a3-e054064041d8',
      width: 5,
      height: 3,
    },
    {
      no: 5,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore5.jpg?alt=media&token=3322a5c1-f199-415b-9e50-f9ddc705b41a',
      width: 5,
      height: 3,
    },
    {
      no: 6,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore6.jpg?alt=media&token=64565e21-dd52-4fae-ad10-c466deea80ea',
      width: 5,
      height: 3,
    },
    {
      no: 7,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore7.jpg?alt=media&token=3ad34623-7566-46e6-8c50-b484f1367248',
      width: 5,
      height: 3,
    },
    {
      no: 8,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore8.jpg?alt=media&token=5729e5cd-3b4c-4ccd-87d4-70de91f97dea',
      width: 5,
      height: 3,
    },
    {
      no: 9,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore9.jpg?alt=media&token=48477de4-d8c0-4834-bbf0-58d8ea28a153',
      width: 5,
      height: 3,
    },
    {
      no: 10,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore10.jpg?alt=media&token=2fc24795-9da6-45e6-91c7-994d40104112',
      width: 5,
      height: 3,
    },
    {
      no: 11,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore11.jpg?alt=media&token=33a4cb0d-767e-49c5-91f4-7e804d94e58b',
      width: 5,
      height: 3,
    },
    {
      no: 12,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore12.jpg?alt=media&token=d41af015-a36a-4dc4-bb9e-f54ffe4314bb',
      width: 5,
      height: 3,
    },
    {
      no: 13,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore13.jpg?alt=media&token=9900a4f4-0642-4ed9-b351-d74eab987f0a',
      width: 3,
      height: 4,
    },
    {
      no: 14,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore14.jpg?alt=media&token=21c41c69-4d43-4e50-bfe3-70bb700a9ba3',
      width: 5,
      height: 3,
    },
    {
      no: 15,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore15.jpg?alt=media&token=943592e4-efc6-4f80-b748-22ae5b908677',
      width: 5,
      height: 3,
    },
    {
      no: 16,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore16.jpg?alt=media&token=29e4e23e-1aec-469c-80ea-ab31ff13dc36',
      width: 5,
      height: 3,
    },
    {
      no: 17,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore17.JPG?alt=media&token=eeb176bb-1175-46ce-9e39-164f68a4369e',
      width: 5,
      height: 3,
    },
    {
      no: 18,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore5.jpg?alt=media&token=3322a5c1-f199-415b-9e50-f9ddc705b41a',
      width: 5,
      height: 3,
    },
    {
      no: 19,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore19.jpg?alt=media&token=519da988-352b-4020-8c1c-2e02067eac2a',
      width: 5,
      height: 3,
    },
    {
      no: 20,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore20.jpg?alt=media&token=84a593ef-bd2d-4db4-9efc-6c159707e546',
      width: 5,
      height: 3,
    },
    {
      no: 21,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore21.jpg?alt=media&token=ec40a76b-3204-4075-9ac3-0c516fe0d025        ',
      width: 5,
      height: 3,
    },
    {
      no: 22,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore22.jpg?alt=media&token=9c249662-3cb9-4236-b701-71d54f056e67',
      width: 5,
      height: 3,
    },
    {
      no: 23,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore23.jpg?alt=media&token=f0576c9a-e355-4f9d-8f4f-abc8f72186bc',
      width: 5,
      height: 3,
    },
    {
      no: 24,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore24.jpg?alt=media&token=69e24200-24b2-4ef2-8cb8-84f21a1ecfe1',
      width: 5,
      height: 3,
    },
    {
      no: 25,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore25.jpg?alt=media&token=a79b0016-c377-456a-9416-07d43fb708bb',
      width: 5,
      height: 3,
    },
    {
      no: 26,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore26.JPG?alt=media&token=4b337915-8d52-4882-8fab-e5a6ed9ad19a',
      width: 5,
      height: 3,
    },
    {
      no: 27,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore27.JPG?alt=media&token=27cc4562-7667-407a-ba9e-ce731c2e6148',
      width: 5,
      height: 3,
    },

    {
      no: 32,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore32.JPG?alt=media&token=dfb08cd4-ab0e-43ce-9382-a0868420e597',
      width: 3,
      height: 5,
    },
    {
      no: 33,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore33.JPG?alt=media&token=bbf47583-b86c-4c37-af07-e1dd1952b4ea',
      width: 5,
      height: 3,
    },
    {
      no: 34,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore34.JPG?alt=media&token=20e292e0-011f-4255-a263-3d7e8ae51ac8',
      width: 5,
      height: 3,
    },
    {
      no: 35,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore35.JPG?alt=media&token=81f911f7-232a-4e14-bba9-b3569542951f        ',
      width: 5,
      height: 3,
    },
    {
      no: 36,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore36.JPG?alt=media&token=aeae2f93-5cc0-4ba3-b377-ef50464f7eba        ',
      width: 5,
      height: 3,
    },
    {
      no: 37,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore37.JPG?alt=media&token=58ee287e-9b2e-4b72-aa69-32ca789e85fd',
      width: 5,
      height: 3,
    },

    {
      no: 38,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore38.JPG?alt=media&token=b793a5e5-08f0-4087-9659-4086985f24ee        ',
      width: 5,
      height: 3,
    },
    {
      no: 39,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore39.JPG?alt=media&token=792e09a0-c03a-4799-b576-f9e65d83ceea',
      width: 3,
      height: 4,
    },
    {
      no: 40,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fsingapore40.JPG?alt=media&token=3d472d36-8553-4372-8778-56240a07bf9a        ',
      width: 3,
      height: 4,
    },
  ];

  const china = [
    {
      no: 1,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fchina1.JPG?alt=media&token=febfea28-8a76-45d5-a3d9-33437fd523a2',
      width: 5,
      height: 3,
    },
    {
      no: 2,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fchina2.JPG?alt=media&token=a2bf236d-ca94-4dac-87de-66836b37b9f2        ',
      width: 5,
      height: 3,
    },
    {
      no: 3,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fchina3.JPG?alt=media&token=01a217f7-25ec-43c9-8d86-9f39eb72f33e',
      width: 5,
      height: 3,
    },
    {
      no: 4,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fchina4.JPG?alt=media&token=db5e8691-f752-4ad7-b021-704934b39105',
      width: 5,
      height: 3,
    },
    {
      no: 5,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fchina5.JPG?alt=media&token=9ca22979-ff5e-4b3d-b260-6b0d903a58ed        ',
      width: 5,
      height: 3,
    },
    {
      no: 6,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fchina6.JPG?alt=media&token=498f62a6-7c27-4d39-aae0-53889360916a        ',
      width: 5,
      height: 3,
    },
    {
      no: 8,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fchina8.JPG?alt=media&token=25305166-0ab6-4f67-b8e2-c127c98bcd44',
      width: 5,
      height: 3,
    },
    {
      no: 9,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fchina9.JPG?alt=media&token=6e62b4b0-a90f-4038-acc6-803b264b34d6',
      width: 5,
      height: 3,
    },
  ];

  const DreamYoga2020 = [
    {
      no: 1,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa1.JPG?alt=media&token=b6f6825b-6783-4fab-9eed-c5354a256b31',
      width: 5,
      height: 3,
    },
    {
      no: 2,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa2.JPG?alt=media&token=ea236c33-9fc6-43f6-961c-e7428df92d03',
      width: 5,
      height: 3,
    },
    {
      no: 3,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa3.JPG?alt=media&token=f93a08d5-bab7-4735-b2b1-751b01c30eba        ',
      width: 5,
      height: 3,
    },
    {
      no: 4,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa4.JPG?alt=media&token=a5b74527-134a-4bba-9211-cca8d6050a22',
      width: 5,
      height: 3,
    },
    {
      no: 5,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa5.JPG?alt=media&token=6bae6e22-6bec-43a3-a745-3dd864a5f1c8',
      width: 5,
      height: 3,
    },
    {
      no: 6,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa6.JPG?alt=media&token=ba958645-81ac-4652-853b-3c2db3bea0bb        ',
      width: 5,
      height: 3,
    },
    {
      no: 7,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa7.JPG?alt=media&token=ae1eaa21-479e-42d7-98b7-0d0a17340eda',
      width: 5,
      height: 3,
    },
    {
      no: 8,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa8.JPG?alt=media&token=a9c475fb-de8e-4afe-9912-c5faeb0e8d49',
      width: 5,
      height: 3,
    },
    {
      no: 9,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa9.JPG?alt=media&token=286819d7-e6d0-466e-ae5c-a6229113ce72',
      width: 5,
      height: 3,
    },
    {
      no: 10,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa10.JPG?alt=media&token=f1234e10-dc72-4c76-a9e0-aa63c4bb6210        ',
      width: 5,
      height: 3,
    },
    {
      no: 11,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa11.JPG?alt=media&token=8fdf3fc9-55fa-4318-9ee4-c3cd8ebf4973',
      width: 5,
      height: 3,
    },
    {
      no: 12,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa12.JPG?alt=media&token=6a708212-9ae5-4d83-9c8b-ec7975e6e1ad        ',
      width: 5,
      height: 3,
    },
    {
      no: 13,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa13.JPG?alt=media&token=31d2f301-9bb9-44ff-877d-538a051deefb        ',
      width: 5,
      height: 3,
    },
    {
      no: 14,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa14.JPG?alt=media&token=0aea3e8b-fb6f-45bb-98c7-cf01ed786c98        ',
      width: 5,
      height: 3,
    },
    {
      no: 15,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa15.JPG?alt=media&token=59dacfff-5069-42d6-a848-5b88dc309ff9',
      width: 5,
      height: 3,
    },
    {
      no: 16,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa16.JPG?alt=media&token=e9a6f656-adca-4f06-82ee-e3ca4c9b713c',
      width: 5,
      height: 3,
    },
    {
      no: 17,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa17.JPG?alt=media&token=27a7f97b-c689-45b2-b324-81d10c3b7d32',
      width: 3,
      height: 5,
    },
    {
      no: 18,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa18.JPG?alt=media&token=74e17526-1ca9-4143-b91a-ad93552becc8',
      width: 5,
      height: 3,
    },
    {
      no: 19,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa19.JPG?alt=media&token=9e8bf8c1-c969-41cc-912e-a28fab230b34',
      width: 5,
      height: 3,
    },
    {
      no: 20,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa20.JPG?alt=media&token=cf69cad4-7a10-4886-9217-a8887a5bca84',
      width: 5,
      height: 3,
    },
    {
      no: 21,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa21.JPG?alt=media&token=5df52edd-df03-40a1-884b-88cb30b511ce',
      width: 5,
      height: 3,
    },
    {
      no: 22,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa22.JPG?alt=media&token=cf230453-a603-4cbf-a1d6-06b964298edc',
      width: 5,
      height: 3,
    },
    {
      no: 23,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa23.JPG?alt=media&token=025d8bdc-070a-4b2a-a389-9c645cc698b1',
      width: 3,
      height: 5,
    },
    {
      no: 24,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa24.JPG?alt=media&token=3c7b48d5-9708-44dd-803a-c340a6d804bb',
      width: 5,
      height: 3,
    },
    {
      no: 25,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa25.JPG?alt=media&token=d4e8c6f4-a8a6-4563-9f51-eb903b4fba80',
      width: 5,
      height: 3,
    },
    {
      no: 26,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa26.JPG?alt=media&token=a91c8a04-03ee-450f-903f-f10ef40ea3e2        ',
      width: 5,
      height: 3,
    },
    {
      no: 27,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F2020-DreamYoGa27.JPG?alt=media&token=ac0c7741-a944-481b-89d2-775fa36580f4',
      width: 5,
      height: 3,
    },
  ];

  const images2020 = [
    {
      no: 1,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-20201.jpg?alt=media&token=c801e8ef-b10d-4bc7-a53b-7212d6954800',
      width: 5,
      height: 3,
    },
    {
      no: 2,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-20202.jpg?alt=media&token=8f3118c3-d12a-4f3b-8dab-a9acc45911a6',
      width: 5,
      height: 3,
    },
    {
      no: 3,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-20203.jpg?alt=media&token=38561476-4861-4ad0-9700-5392bb9cb01a        ',
      width: 5,
      height: 3,
    },
    {
      no: 4,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-20204.jpg?alt=media&token=0373b7b0-8de2-40c0-9b15-214f531c1893        ',
      width: 5,
      height: 3,
    },
    {
      no: 5,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-20205.jpg?alt=media&token=38e8e402-2379-4b75-9662-50edb0b7f27e',
      width: 5,
      height: 3,
    },
    {
      no: 6,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-20206.jpg?alt=media&token=7efff69c-edea-4cf9-8345-a18b63053205',
      width: 5,
      height: 3,
    },
    {
      no: 7,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-20207.jpg?alt=media&token=57f6356d-c081-4d62-87f2-4954351172a0',
      width: 5,
      height: 3,
    },
    {
      no: 8,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-20208.jpg?alt=media&token=722a3b31-8871-4683-8117-db227709d85c',
      width: 5,
      height: 3,
    },
    {
      no: 9,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-20209.jpg?alt=media&token=1d86daaa-a649-44c0-a3aa-1988dca5454c        ',
      width: 5,
      height: 3,
    },
    {
      no: 10,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202010.jpg?alt=media&token=695fd785-1ea8-443a-83c7-b8518b3eb940',
      width: 5,
      height: 3,
    },
    {
      no: 11,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202011.JPG?alt=media&token=86b4b0df-9305-4281-82ef-2d8cc0f3fc2f      ',
      width: 5,
      height: 3,
    },
    {
      no: 12,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202012.JPG?alt=media&token=4bea5e25-1545-4c31-94b4-03b6a0c08cb6      ',
      width: 5,
      height: 3,
    },
    {
      no: 13,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202013.JPG?alt=media&token=6a65f53a-f1f5-49b7-aad8-e7b922230e5b',
      width: 5,
      height: 3,
    },

    {
      no: 14,
      src:
        ' https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202014.JPG?alt=media&token=93ec6678-ae5c-41d8-8a44-a0e0bf718c73',
      width: 5,
      height: 3,
    },
    {
      no: 15,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202015.JPG?alt=media&token=14ed7921-b3f7-4eb0-a55c-fd560c9f623a',
      width: 3,
      height: 5,
    },
    {
      no: 16,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202016.JPG?alt=media&token=b0069c72-dc4d-4559-bf23-6ab5c1a291d6',
      width: 5,
      height: 3,
    },
    {
      no: 17,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202017.JPG?alt=media&token=7a03f865-fc90-45c6-ad62-8f262846b010',
      width: 5,
      height: 3,
    },
    {
      no: 18,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202018.JPG?alt=media&token=c0ecc988-e9c8-4ed3-8a97-efea928666c7',
      width: 5,
      height: 3,
    },
    {
      no: 19,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202019.JPG?alt=media&token=521d9ed9-0415-4638-9352-64fc879e01ad      ',
      width: 5,
      height: 3,
    },
    {
      no: 20,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202020.JPG?alt=media&token=51955932-f71c-4395-9afe-e1951f1e2743  ',
      width: 5,
      height: 3,
    },
    {
      no: 21,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202021.JPG?alt=media&token=2b5158aa-516a-4df5-8a63-cbfe4d60d337',
      width: 5,
      height: 3,
    },
    {
      no: 22,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202022.JPG?alt=media&token=c1d66801-ee3a-401a-aa42-5dde741c720c',
      width: 5,
      height: 3,
    },
    {
      no: 23,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202023.JPG?alt=media&token=c8d6c709-1a60-4d24-9aae-055768e59ad3        ',
      width: 5,
      height: 3,
    },
    {
      no: 24,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202024.JPG?alt=media&token=4b658a73-6be7-40d7-8ba4-a4b4882a3046',
      width: 5,
      height: 3,
    },
    {
      no: 25,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202025.JPG?alt=media&token=d385dc5e-99c4-44f1-a697-87db9aa31012',
      width: 5,
      height: 3,
    },
    {
      no: 26,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202026.JPG?alt=media&token=735d8ee4-2e38-4bab-ba23-2e95d3d60b70        ',
      width: 5,
      height: 3,
    },
    {
      no: 27,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202027.JPG?alt=media&token=32e93823-06bb-4ad1-9acb-9b2575bf5fb7',
      width: 5,
      height: 3,
    },
    {
      no: 28,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202028.JPG?alt=media&token=49c09813-806a-48e5-a87f-4de80ee84fec',
      width: 5,
      height: 3,
    },
    {
      no: 29,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202029.JPG?alt=media&token=2e117e0d-a736-4692-974e-b6b417b530f2',
      width: 5,
      height: 3,
    },
    {
      no: 30,
      src:
        ' https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202030.JPG?alt=media&token=ccb57854-7dcc-4395-99e0-1b3d2096f514',
      width: 5,
      height: 3,
    },
    {
      no: 31,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202031.JPG?alt=media&token=0ab8cd63-720b-4c3e-976f-2a620d8e0517        ',
      width: 5,
      height: 3,
    },
    {
      no: 32,
      src:
        ' https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202032.JPG?alt=media&token=975fff2e-feee-4212-8d09-f259504304e2',
      width: 5,
      height: 3,
    },
    {
      no: 33,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202033.JPG?alt=media&token=4014719f-0b61-441b-b543-bacf90b83350        ',
      width: 5,
      height: 3,
    },
    {
      no: 34,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202034.JPG?alt=media&token=0d95137b-ade6-4bb8-a703-6352a3fba116',
      width: 5,
      height: 3,
    },
    {
      no: 35,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202035.JPG?alt=media&token=5f571e89-e0d2-4a6d-95c5-83986bf694ce',
      width: 5,
      height: 3,
    },
    {
      no: 36,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202036.JPG?alt=media&token=07079009-345a-4706-b605-e5075ae8f65d',
      width: 5,
      height: 3,
    },
    {
      no: 37,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202037.JPG?alt=media&token=4b95f3fd-e1c2-4cd9-b533-87063f82daff        ',
      width: 5,
      height: 3,
    },
    {
      no: 38,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202038.JPG?alt=media&token=123d113b-200c-4c08-a2f9-5e1f64a2131a',
      width: 5,
      height: 3,
    },
    {
      no: 39,
      src:
        ' https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202039.JPG?alt=media&token=09b2098d-cc59-402e-8f90-51d4c2237b07',
      width: 5,
      height: 3,
    },
    {
      no: 40,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202040.JPG?alt=media&token=90cf7ce5-08e2-47fe-9b93-6ae50f8ff6f0',
      width: 5,
      height: 3,
    },
    {
      no: 41,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202041.JPG?alt=media&token=c202a63b-5c01-4f56-9854-55eaf039b5df',
      width: 5,
      height: 3,
    },
    {
      no: 42,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202042.JPG?alt=media&token=070d9dd1-1ea9-4cc6-a66d-a333e35b930d',
      width: 3,
      height: 5,
    },
    {
      no: 43,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202043.JPG?alt=media&token=1e05b742-9a04-4c74-930f-95a3f0704a5f',
      width: 5,
      height: 3,
    },
    {
      no: 44,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202044.JPG?alt=media&token=1de307fb-9ffd-4ed1-b50a-d2aed6c2477f',
      width: 5,
      height: 3,
    },
    {
      no: 45,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202045.JPG?alt=media&token=a458e509-3ffd-410d-b0bc-86e8070ea9a1',
      width: 5,
      height: 3,
    },
    {
      no: 46,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202046.JPG?alt=media&token=744ce6ee-5f08-41d9-9c54-78bd80760b55        ',
      width: 5,
      height: 3,
    },
    {
      no: 47,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202047.JPG?alt=media&token=bc5a087c-1740-4677-8a9b-1d104c87c2f6',
      width: 5,
      height: 3,
    },
    {
      no: 48,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202048.JPG?alt=media&token=dc8e639f-4082-4699-b584-746a5bbf3984',
      width: 5,
      height: 3,
    },
    {
      no: 49,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202049.JPG?alt=media&token=f3ae0d53-fcba-4c09-a0f7-f22ca14562ae        ',
      width: 3,
      height: 5,
    },
    {
      no: 50,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202050.JPG?alt=media&token=14871c24-313a-4c10-8caf-1e5b06938ff9',
      width: 5,
      height: 3,
    },
    {
      no: 51,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202051.JPG?alt=media&token=231fbb68-9da2-4372-897b-cb62d61a4fa6        ',
      width: 3,
      height: 5,
    },
    {
      no: 52,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202052.JPG?alt=media&token=292184e2-e64a-4505-b58e-c2e6e6c8303c        ',
      width: 5,
      height: 3,
    },
    {
      no: 53,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202053.JPG?alt=media&token=169f48bc-8720-4e5a-ae11-154498ee9c79',
      width: 5,
      height: 3,
    },
    {
      no: 54,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202054.JPG?alt=media&token=ea806923-82c0-434c-965b-4029b728c58b',
      width: 5,
      height: 3,
    },
    {
      no: 55,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202055.JPG?alt=media&token=f5109cda-b3bc-4deb-9bba-dea2b97589e0',
      width: 5,
      height: 3,
    },
    {
      no: 56,
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2F%E5%B9%BB%E8%BC%AA-202056.JPG?alt=media&token=cc9360f7-0319-4dcc-ad7b-bb8b86fb83d3',
      width: 5,
      height: 3,
    },
  ];

  const tibetVisit =[
    {
      // no 1
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit1.JPG?alt=media&token=d7c23df9-72b4-462d-a55c-511c308ff34e',
      width: 5,
      height: 3
    },
    {
      // no 2
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit2.JPG?alt=media&token=0232ad8a-fa97-4201-b33d-eb430e51fd10',
      width: 5,
      height: 3
    },
    {
      // no 3
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit3.JPG?alt=media&token=2fa99afd-8ad6-43d8-a732-f426632fc871',
      width: 5,
      height: 3
    },
    {
      // no 4
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit4.JPG?alt=media&token=cbd1a36b-accd-4de0-a2a8-b8e4f235c59b',
      width: 5,
      height: 3
    },
    {
      // no 5
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit5.JPG?alt=media&token=6fe4b0e3-d7d2-4448-9737-3559dc0cd5a6',
      width: 5,
      height: 3
    },
    {
      // no 6
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit6.JPG?alt=media&token=8bed30ff-2684-4d60-86e6-9a22a585bb84',
      width: 5,
      height: 3
    },
    {
      // no 7
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit7.JPG?alt=media&token=c25ea808-ede7-46cc-981c-dd9ae98083da',
      width: 5,
      height: 3
    },
    {
      // no 8
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit8.JPG?alt=media&token=c0564db9-0ebb-4810-a30a-fec6beea2793      ',
      width: 5,
      height: 3
    },
    {
      // no 9
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit9.JPG?alt=media&token=dc34e5a5-764e-4420-904d-4d3673c1e0f1',
      width: 5,
      height: 3
    },
    {
      // no 10
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit10.JPG?alt=media&token=49b5d5dc-4fdc-45ee-a3bf-d57b8b245303',
      width: 5,
      height: 3
    },
    {
      // no 11
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit11.JPG?alt=media&token=2fc61a9d-2286-42ab-aad8-675330ebbd81',
      width: 5,
      height: 3
    },
    {
      // no 12
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit12.JPG?alt=media&token=961f6626-db38-4e9a-a734-78b52d9ee47c',
      width: 5,
      height: 3
    },
    {
      // no 13
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit13.JPG?alt=media&token=37c66a5f-b111-4722-a6d2-a8d14763d41b',
      width: 5,
      height: 3
    },
    {
      // no 14
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit14.JPG?alt=media&token=1f6fdb4c-3dc4-41bd-974e-47a25ec8a4b4',
      width: 5,
      height: 3
    },
    {
      // no 15
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit15.JPG?alt=media&token=3b92464e-0193-4a40-92e6-454267084b0e',
      width: 5,
      height: 3
    },
    {
      // no 16
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit16.JPG?alt=media&token=2227a930-f92b-4057-8767-b0230f757816',
      width: 5,
      height: 3
    },
    {
      // no 17
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit17.JPG?alt=media&token=5d39d2c5-71ee-4e60-92b6-cb454560c13e      ',
      width: 5,
      height: 3
    },
    {
      // no 18
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit18.JPG?alt=media&token=c4d0b651-0633-456c-a086-bd39aa4bb2ca      ',
      width: 5,
      height: 3
    },
    {
      // no 19
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit19.JPG?alt=media&token=41ea7fd0-0248-4f01-b69b-07d2f6a0fc8c',
      width: 5,
      height: 3
    },
    {
      // no 20
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit20.JPG?alt=media&token=a88a21ea-364e-4f1e-a660-9232a68d411e',
      width: 5,
      height: 3
    },
    {
      // no 21
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit21.JPG?alt=media&token=200956dc-b7c3-4833-89f0-a20de8d2073b',
      width: 5,
      height: 3
    },
    {
      // no 22
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit22.JPG?alt=media&token=70be4b0e-dfb5-4156-8199-d833effe7229',
      width: 5,
      height: 3
    },
    {
      // no 23
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit23.JPG?alt=media&token=30ab455d-93da-42e1-bf97-45037ae8b821',
      width: 5,
      height: 3
    },
    {
      // no 24
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit24.JPG?alt=media&token=2ca9144d-c9c5-494f-a3a6-26ca4e23e17d',
      width: 5,
      height: 3
    },
    {
      // no 25
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit25.JPG?alt=media&token=a352acac-a703-4d20-a11c-9b22546bfdc4',
      width: 5,
      height: 3
    },
    {
      // no 26
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit26.JPG?alt=media&token=9e906ad5-b52b-4c16-97ad-ef08ea2e0f26',
      width: 5,
      height: 3
    },
    {
      // no 27
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit27.JPG?alt=media&token=4c6336ad-c28c-47b3-9c67-c08e260a0ed7',
      width: 5,
      height: 3
    },
    {
      // no 28
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit28.JPG?alt=media&token=cf3be193-7df1-4c3e-9c87-dafd8ea0a642',
      width: 5,
      height: 3
    },
    {
      // no 29
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FtibetVisit29.JPG?alt=media&token=98e28314-b94b-4e88-8ec1-ec3c84c933ac',
      width: 5,
      height: 3
    },

  ]
  return (
    <>
      <Header />
      <Container>
        <div className='content'>
          <div>
            <h3 className='text-secondary '>画廊</h3>
          </div>
          <div className='p-3'>
            <Tab.Container id='left-tabs' defaultActiveKey='first'>
              <Row>
                <Col sm={3}>
                  <Nav variant='pills' className='flex-column'>
                    <Nav.Item className='navItem'>
                      <Nav.Link eventKey='first'>
                        <h4>
                          台灣{' '}
                          <span role='img' aria-label='taiwan'>
                            🇹🇼
                          </span>
                        </h4>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className='navItem'>
                      <Nav.Link eventKey='second'>
                        <h4>
                          新加坡{' '}
                          <span role='img' aria-label='singapore'>
                            🇸🇬
                          </span>
                        </h4>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className='navItem'>
                      <Nav.Link eventKey='third'>
                        <h4>
                          馬來西亞{' '}
                          <span role='img' aria-label='malaysia'>
                            🇲🇾
                          </span>
                        </h4>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className='navItem'>
                      <Nav.Link eventKey='forth'>
                        <h4>中國</h4>
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item className='navItem'>
                      <Nav.Link eventKey='fifth'>
                        <h4>Tibet Visit</h4>
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Col>
                <Col sm={9}>
                  <Tab.Content className='tabContent'>
                    <Tab.Pane eventKey='first' className='tabPane'>
                      {/* internal Tabs */}
                      <Tabs defaultActiveKey='new'>
                        {/* inner tab-0 */}
                        <Tab
                          className='innerTab'
                          eventKey='new'
                          title='🌟 2020 New'
                        >
                          <h3>夢瑜伽2020 （台中)</h3>
                          <PhotoGallery images={DreamYoga2020} />
                          <h3>幻輪 （台中）2020</h3>
                          <PhotoGallery images={images2020} />
                        </Tab>
                        {/* inner tab-1 */}
                        <Tab
                          className='innerTab'
                          eventKey='台北監獄'
                          title='台北監獄'
                        >
                          <h3>时间：2015-2018</h3>
                          <PhotoGallery images={jailPhotos} />
                        </Tab>
                        {/* inner tab-2 */}
                        <Tab
                          className='innerTab'
                          eventKey='佛研會'
                          title='佛研會'
                        >
                          <h3>内容：夢瑜伽 (2018)</h3>
                          <PhotoGallery images={BDA2018} />
                          <h3>内容：破瓦法 (2017)</h3>
                          <PhotoGallery images={BDA2017} />
                          <h3>内容：氣的竅訣 (2016)</h3>
                          <PhotoGallery images={BDA2016} />
                        </Tab>

                        {/* inner tab-3 */}

                        <Tab
                          className='innerTab'
                          eventKey='桃園般若禅林'
                          title='桃園般若禅林'
                        >
                          <h3>大手印禪修指導 (2017-2019)</h3>
                          <PhotoGallery images={meditation} />
                        </Tab>
                        {/*  inner tab-4 */}
                        <Tab
                          className='innerTab'
                          eventKey='華梵大學禪修'
                          title='華梵大學禪修'
                        >
                          <h3>禪修指導(2018)</h3>
                          <PhotoGallery images={meditationGuid} />
                        </Tab>

                        {/* inner tab-5 */}
                        <Tab
                          className='innerTab'
                          eventKey='漢聲廣播專訪'
                          title='漢聲廣播專訪'
                        >
                          <h3>漢聲廣播專訪</h3>
                          <PhotoGallery images={interview} />
                        </Tab>
                        {/* inner tab-6 */}
                        <Tab
                          className='innerTab'
                          eventKey='菩提佛學會'
                          title='菩提佛學會'
                        >
                          <h3>菩提佛學會</h3>
                          <PhotoGallery images={taiwanCenter} />
                        </Tab>
                      </Tabs>
                    </Tab.Pane>
                    <Tab.Pane eventKey='second' className='tabPane'>
                      <h3>singapore</h3>
                      <PhotoGallery images={singapore} />
                      {/* <p>i am Singapore</p> */}
                    </Tab.Pane>
                    <Tab.Pane eventKey='third' className='tabPane'>
                      <p>i am malaysia</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey='forth' className='tabPane'>
                      <h3>CHINA</h3>
                      <PhotoGallery images={china} />
                    </Tab.Pane>
                    <Tab.Pane eventKey='fifth' className='tabPane'>
                      <h3>Tibet Visit</h3>
                      <PhotoGallery images={tibetVisit} />
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </div>
        </div>
      </Container>
    </>
  );
}

export default Gallery;
